<template>
<layout-content :title="`${editName}`">
  <template #body>
    <el-table
      ref="table"
      :data="deviceFactors"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @selection-change="onSelectionChange"
      @row-click="onOpenEditor"
    >
      <el-table-column label="序号" width="50">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column>

      <el-table-column prop="displayName" label="因子名称" />
      <el-table-column prop="cas" label="cas" />
      <el-table-column prop="molecular" label="分子量" />
      <el-table-column prop="stdUnit" label="标准单位" />
      <el-table-column prop="displayUnit" label="显示单位" />
      <el-table-column label="分组">
        <template slot-scope="{row}">{{(factorGroupMap[row.groupId] || {}).name}}</template>
      </el-table-column>
    </el-table>
  </template>
</layout-content>
</template>

<script>
import {DEVICE_SELECT_CHANGED} from './EventKeys'
import BaseListEditor from '../../../BaseListEditor'

export default {
  name: 'DeviceFactor',
  extends: BaseListEditor,
  computed: {
    apiKey () {
      return 'DeviceFactor'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return '设备因子'
    },
    deviceFactors () {
      let {factorMap} = this
      return this.list.map(({factorId}) => factorMap[factorId]).filter(factor => factor)
    }
  },
  methods: {
    onDeviceSelectChanged (device) {
      let {id: deviceId} = device

      if (!deviceId) {
        this.device = null
        this.list = []
        return
      }

      device = this.device = Object.freeze(JSON.parse(JSON.stringify(device)))
      this.query.deviceId = deviceId
      this.getList()
    }
  },
  created () {
    this.$eventBus.on(DEVICE_SELECT_CHANGED, this.onDeviceSelectChanged)
  },
  beforeDestroy () {
    this.$eventBus.off(DEVICE_SELECT_CHANGED, this.onDeviceSelectChanged)
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/03Device/DeviceFactor.vue